import { userActions } from '@/actions';
import { track } from '@/helpers/tracking';
import { Tracking } from '@/types/analytics';
import { Dispatch } from 'react';
import { favoriteServices } from '../services';

type FavouriteTracking = { companyName: string; initiatedFrom: Tracking.FavouriteInitiatedFrom };

const trackFavourite = <K extends 'Favourite Added' | 'Favourite Removed'>(
  name: K,
  placeId: number,
  { companyName, initiatedFrom }: FavouriteTracking,
) =>
  track(name, {
    favourite_type: 'place',
    place_id: String(placeId),
    place_name: companyName,
    // The schema's screen is place_details; the deprecated initiated_from keeps company_details.
    screen_name: initiatedFrom === 'company_details' ? 'place_details' : initiatedFrom,
    initiated_from: initiatedFrom,
  });

const add =
  (placeId: number, user: any, tracking: FavouriteTracking, successCallback?: () => void) =>
  (dispatch: Dispatch<any>) =>
    favoriteServices.add(placeId).then(() => {
      if (user && !user.favorites) user.favorites = [];
      user.favorites.push(placeId);
      dispatch(userActions.updateUser(user, true));
      trackFavourite('Favourite Added', placeId, tracking);
      successCallback?.();
    });

const remove =
  (placeId: number, user: any, tracking: FavouriteTracking, successCallback?: () => void) =>
  (dispatch: Dispatch<any>) =>
    favoriteServices.remove(placeId).then(() => {
      if (user && user.favorites) {
        user.favorites = user.favorites.filter((id) => id !== placeId);
      }
      dispatch(userActions.updateUser(user, true));
      trackFavourite('Favourite Removed', placeId, tracking);
      successCallback?.();
    });

export const favoriteActions = {
  add,
  remove,
};
